import { apiClient } from './api-client';

/**
 * Fetches a single qwanta by its unique _id
 * 
 * @param {string|ObjectId} id - The unique _id of the qwanta to retrieve
 * @returns {Promise<Object|null>} - The qwanta object if found, null otherwise
 */
export async function getQwanta(id) {
    try {
        // Use API client to get the document
        const result = await apiClient.get(`/api/qwanyx/sync/${id}`);
        
        if (!result) {
            return null;
        }

        // Return the complete document
        return result;
    } catch (error) {
        console.error("Error fetching qwanta:", error);
        throw error;
    }
}